import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import InputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import ReactTooltip from "react-tooltip";
import { getRequest, postRequest } from "../../Services/axios.service";
import { DOCUMENT, DOMINICAN, PASSPORT } from "../../Utils/constants.api";
import { normalizePhone } from "../../Utils/normalize";
import { colourStyles } from "../../Utils/styled-components/react-select.style";
import {
    CLIENT,
    DOCUMENT_TYPE,
    NATIONALITY,
    VALIDATE
} from "../../Utils/url.api";
import { GoogleSingIn } from "./GoogleSingIn";

export const SignUp = () => {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    watch,
  } = useForm({ mode: "onBlur" });
  const [documentTypes, setDocumentTypes] = useState();
  const [nationalities, setNationalities] = useState();
  const [inputConfig, setInputConfig] = useState({
    documentLabel: "Identificación",
    documentMask: "999-9999999-9",
    documentError: "Cedula no valida",
  });
  const navigate = useNavigate();
  const [_nationalities, _setNationalities] = useState();
  const [loadingSet, setLoadingSet] = useState({
    documentLoading: false,
    submitLoading: false,
    nationalityLoading: false,
    pageLoading: false,
  });

  useEffect(() => {
    fetchDocumentType();
    fetchNationality();
  }, []);

  const fetchDocumentType = async () => {
    const params = new URLSearchParams([
      ["fields", "description,id,identificator"],
      ["except", "TO"],
    ]);
    setLoadingSet((cur) => ({ ...cur, pageLoading: true }));
    const response = await getRequest(`${DOCUMENT_TYPE}`, { params });
    setLoadingSet((cur) => ({ ...cur, pageLoading: false }));
    const { success, statusCode, data } = response.data;
    if (statusCode == 200) {
      setValue(
        "documentTypeId",
        data.find((x) => x.identificator === DOCUMENT)?.id
      );
      setDocumentTypes((document) =>
        data.filter(
          (x) => x.identificator === DOCUMENT || x.identificator === PASSPORT
        )
      );
      setInputConfig((config) => ({
        ...config,
        documentLabel: data?.[0]?.description ?? config.documentLabel,
      }));
    }
  };

  const fetchNationality = async () => {
    setLoadingSet((cur) => ({ ...cur, nationalityLoading: true }));
    const response = await getRequest(`${NATIONALITY}`);
    setLoadingSet((cur) => ({ ...cur, nationalityLoading: false }));
    const { success, statusCode, data } = response.data;
    if (statusCode == 200) {
      setNationalities((curr) => data);
      _setNationalities(data);
      setValue("nationalityId", DOMINICAN);
    }
  };

  const onDocumentTypeChange = (value) => {
    const selected = documentTypes.find((type) => type.id === value);
    if (selected?.identificator === DOCUMENT) {
      setNationalities((list) =>
        _nationalities.filter((x) => x.id == DOMINICAN)
      );
      setValue("nationalityId", DOMINICAN, { shouldValidate: true });
      setValue("documentNumber", null);
      setValue("fullName", null);
      setValue("birthDate", null);
    } else {
      setNationalities((list) =>
        _nationalities.filter((x) => x.id != DOMINICAN)
      );
      setValue("nationalityId", null);
      setValue("documentNumber", null);
      setValue("fullName", null);
      setValue("birthDate", null);
    }
    setInputConfig((config) => ({
      ...config,
      documentMask:
        selected?.identificator === DOCUMENT ? "999-9999999-9" : null,
      documentLabel: selected?.description ?? config.documentLabel,
    }));
  };

  const validateDocumentNumber = async (value) => {
    
    const document = value.replace(/-/g, "");
    const documentTypeId = getValues("documentTypeId");
    if (documentTypeId === 1 && document.length >= 11) {
      setLoadingSet((cur) => ({ ...cur, documentLoading: true }));
      const response = await getRequest(VALIDATE(documentTypeId, document));
      setLoadingSet((cur) => ({ ...cur, documentLoading: false }));
      const { success, statusCode, data, message } = response.data;
      if (statusCode == 200 && data.fullName) {
        setValue("fullName", data.fullName, { shouldValidate: true });
        if (data.birthDate)
          setValue(
            "birthDate",
            moment(data.birthDate.replace(/-/g, "/").replace(/T.+/, "")).format(
              "YYYY-MM-DD"
            ),
            { shouldValidate: true }
          );
      } else if (statusCode == 201 && !success) {
        setInputConfig((curr) => ({ ...curr, documentError: message }));
        return false;
      } else {
        setInputConfig((curr) => ({ ...curr, documentError: message }));
        return false;
      }
    }
    return true;
  };

  const submitLogin = async (model) => {
    const sendModel = {
      ...model,
      clientTypeId: documentTypes.find(
        (type) => type.id === model.documentTypeId
      )?.identificator,
      documentNumber: model.documentNumber.replace(/-/g, ""),
      phoneNumber: normalizePhone(model?.phoneNumber).toString()
    };
    setLoadingSet((cur) => ({ ...cur, submitLoading: true }));
    await toast
      .promise(postRequest(CLIENT, sendModel), {
        pending: {
          position: "top-center",
          type: "default",
          isLoading: true,
          icon: false,
          render: () => "Espere",
        },
      })
      .then((res) => {
        setLoadingSet((cur) => ({ ...cur, submitLoading: false }));
        if (res.data.statusCode === 201) {
            setTimeout(() => {
              navigate("/login");
            }, 2000);
        } else if (res.data.statusCode === 500) {
          toast(`Ha ocurrido un error, mensaje: ${res.data.message}`, {
            theme: "colored",
            type: "error",
          });
        }
      });
  };

  const isAdult = (date) => {
    const currentDate = moment();
    const birthDate = moment(date);
    return moment.duration(currentDate.diff(birthDate)).years() >= 18;
  };

  return (
    <>
      {loadingSet.pageLoading && <div className="flex justify-center"><div className="spinner-loading"></div></div>}
      {!loadingSet.pageLoading && (
        <div className="text-lg">
          <ToastContainer />
          <span className="text-xl font-medium text-font-primary">
            Coloca tu correo electrónico y contraseña para registrarte
          </span>
          <div className="text-left my-8">
            <form
              className="custom-form"
              onSubmit={handleSubmit((data) => submitLogin(data))}
            >
              <div className="custom-form__control">
                <label className="custom-form__label" htmlFor="email">
                  Correo Electrónico
                  <AiOutlineQuestionCircle
                    className="inline ml-1"
                    fontSize={"1.5rem"}
                    fontWeight={500}
                    data-tip="La información puesta en estos campos puede <br/> ser utilizada para validar información con los <br/> bancos al momento de pagar algunos de nuestros servicios."
                  ></AiOutlineQuestionCircle>
                </label>
                <ReactTooltip multiline={true} type="info" effect="solid"/>
                <input
                  className="custom-form__input"
                  id="email"
                  type="email"
                  {...register("email", {
                    required: {
                      value: true,
                      message: "El correo electrónico es requerido",
                    },
                    pattern: {
                      value:
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Correo invalido",
                    },
                  })}
                />
                {errors.email?.type === "required" && (
                  <p className="text-danger" role="alert">
                    {errors.email?.message}
                  </p>
                )}
                {errors.email?.type === "pattern" && (
                  <p className="text-danger" role="alert">
                    {errors.email?.message}
                  </p>
                )}
                <span className="text-font-muted">
                  Te enviaremos las confirmaciones de ticket electrónico a este
                  correo.
                </span>
              </div>

              <div className="custom-form__control">
                <label className="custom-form__label" htmlFor="password">
                  Contraseña
                </label>
                <input
                  className="custom-form__input"
                  id="password"
                  type="password"
                  autoComplete="off"
                  {...register("password", {
                    required: {
                      message: "La contraseña es requerida",
                      value: true,
                    },
                    pattern: {
                      value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
                      message:
                        "La contraseña debe tener al menos 8 dígitos, una letra en mayúscula, un numero y una letra en minúscula ",
                    },
                  })}
                />
                <span>
                  {errors.password?.type === "required" && (
                    <p className="text-danger" role="alert">
                      {errors.password?.message}
                    </p>
                  )}
                  {errors.password?.type === "pattern" && (
                    <p className="text-warning" role="alert">
                      {errors.password?.message}
                    </p>
                  )}
                </span>
              </div>

              <div className="custom-form__control">
                <label className="custom-form__label" htmlFor="repassword">
                  Confirmar Contraseña
                </label>
                <input
                  className="custom-form__input"
                  id="repassword"
                  type="password"
                  autoComplete="off"
                  {...register("repassword", {
                    required: {
                      message: "Escriba la contraseña nuevamente",
                      value: true,
                    },
                    validate: {
                      equal: (val) => val === getValues("password"),
                    },
                  })}
                />
                <span>
                  {errors.repassword?.type === "required" && (
                    <p className="text-danger" role="alert">
                      {errors.repassword?.message}
                    </p>
                  )}
                  {errors.repassword?.type === "equal" && (
                    <p className="text-danger" role="alert">
                      La contraseñas no coinciden
                    </p>
                  )}
                </span>
              </div>

              <hr className="my-8 border-bd-primary"></hr>

              <div className="custom-form__control">
                <label className="custom-form__label">
                  Tipo de Identificación
                </label>
                <div className="flex">
                  <Controller
                    control={control}
                    name="documentTypeId"
                    rules={{
                      required: {
                        value: true,
                        message: "Este campo es requerido",
                      },
                    }}
                    render={({
                      field: { onChange, name, value, ref, onBlur },
                    }) => (
                      <>
                        {documentTypes?.length > 0 &&
                          documentTypes.map((document, i) => (
                            <label
                              key={i}
                              className="custom-form__checkbox-label"
                              htmlFor={document.id}
                            >
                              <input
                                className="custom-form__radio"
                                type="radio"
                                ref={ref}
                                onChange={(event) => {
                                  onDocumentTypeChange(document.id);
                                  return onChange(document.id);
                                }}
                                onBlur={onBlur}
                                checked={value === document.id}
                                key={document.id}
                              />
                              {document.description}
                            </label>
                          ))}
                      </>
                    )}
                  ></Controller>
                </div>
                <span>
                  {errors.documentTypeId?.type === "required" && (
                    <p className="text-danger" role="alert">
                      {errors.documentTypeId?.message}
                    </p>
                  )}
                </span>
              </div>

              <div className="custom-form__control">
                <label className="custom-form__label" htmlFor="documentNumber">
                  {inputConfig.documentLabel}
                </label>
                <Controller
                  control={control}
                  name="documentNumber"
                  rules={{
                    required: {
                      message: "Este campo es requerido",
                      value: true,
                    },
                    validate: {
                      valid: async (val) => await validateDocumentNumber(val),
                    },
                  }}
                  render={({
                    field: { onChange, name, value, ref, onBlur },
                  }) => (
                    <InputMask
                      id="documentNumber"
                      className="custom-form__input"
                      onChange={(event) => onChange(event.target.value)}
                      onBlur={onBlur}
                      inputRef={ref}
                      mask={inputConfig.documentMask}
                      maskChar=""
                    />
                  )}
                ></Controller>
                <span>
                  {errors.documentNumber?.type === "required" && (
                    <p className="text-danger" role="alert">
                      {errors.documentNumber?.message}
                    </p>
                  )}
                  {errors.documentNumber?.type === "valid" && (
                    <p className="text-danger" role="alert">
                      {inputConfig.documentError}
                    </p>
                  )}
                </span>
              </div>

              <div className="custom-form__control">
                <label className="custom-form__label" htmlFor="fullName">
                  Nombre
                </label>
                <div className="flex gap-x-2 items-center justify-between">
                  <input
                    className="custom-form__input w-full"
                    id="fullName"
                    type="text"
                    autoComplete="off"
                    disabled={watch("documentTypeId") === 1}
                    {...register("fullName", {
                      required: {
                        message: "Este campo es requerido",
                        value: true,
                      },
                    })}
                  />
                  {loadingSet.documentLoading && (
                    <div className="spinner-loading"></div>
                  )}
                </div>
                <span>
                  {errors.fullName?.type === "required" && (
                    <p className="text-danger" role="alert">
                      {errors.fullName?.message}
                    </p>
                  )}
                </span>
              </div>

              <div className="custom-form__control">
                <label className="custom-form__label" htmlFor="birthDate">
                  Fecha de nacimiento
                </label>
                <div className="flex gap-x-2 items-center justify-between">
                  <input
                    className="custom-form__input w-full"
                    id="birthDate"
                    type="date"
                    {...register("birthDate", {
                      valueAsDate: true,
                      required: {
                        message: "Este campo es requerido",
                        value: true,
                      },
                      validate: {
                        lessThanEighteen: (val) => isAdult(val),
                      },
                    })}
                  />
                  {loadingSet.documentLoading && (
                    <div className="spinner-loading"></div>
                  )}
                </div>
                <span>
                  {errors.birthDate?.type === "required" && (
                    <p className="text-danger" role="alert">
                      {errors.birthDate?.message}
                    </p>
                  )}
                  {errors.birthDate?.type === "lessThanEighteen" && (
                    <p className="text-danger" role="alert">
                      No eres mayor de edad
                    </p>
                  )}
                </span>
                <span className="text-font-muted">
                  Debes tener al menos 18 años para registrarte.
                </span>
              </div>

              <hr className="my-8 border-bd-primary"></hr>

              <div className="custom-form__control">
                <label className="custom-form__label">Nacionalidad</label>
                <div className="flex gap-x-2 items-center justify-between">
                  <Controller
                    control={control}
                    defaultValue={1}
                    name="nationalityId"
                    rules={{ required: true }}
                    render={({
                      field: { onChange, name, value, ref, onBlur },
                    }) => (
                      <Select
                        ref={ref}
                        onBlur={onBlur}
                        styles={colourStyles}
                        getOptionLabel={(option) => option?.description}
                        getOptionValue={(option) => option?.id}
                        options={nationalities}
                        onChange={(newValue) => onChange(newValue?.id)}
                        value={nationalities?.find((c) => c?.id === value)}
                        isDisabled={watch("documentTypeId") == 1}
                      />
                    )}
                  ></Controller>
                  {loadingSet.nationalityLoading && (
                    <div className="spinner-loading"></div>
                  )}
                </div>
                <span>
                  {errors.documentTypeId?.type === "required" && (
                    <p className="text-danger" role="alert">
                      {errors.documentTypeId?.message}
                    </p>
                  )}
                </span>
              </div>

              <div className="custom-form__control">
                <label className="custom-form__label" htmlFor="phoneNumber">
                  Número teléfonico
                  <AiOutlineQuestionCircle
                    className="inline ml-1"
                    fontSize={"1.5rem"}
                    fontWeight={500}
                    data-tip="La información puesta en estos campos puede <br/> ser utilizada para validar información con los <br/> bancos al momento de pagar algunos de nuestros servicios."
                  ></AiOutlineQuestionCircle>
                </label>
                <Controller
                  name="phoneNumber"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: {
                      message: "Este campo es requerido",
                      value: true,
                    },
                  }}
                  render={({
                    field: { onChange, name, value, ref, onBlur },
                  }) => (
                    <InputMask
                      id="phoneNumber "
                      className="custom-form__input"
                      onChange={(event) => onChange(event.target.value)}
                      onBlur={onBlur}
                      inputRef={ref}
                      mask="(999)-999-9999"
                      maskChar=""
                      value={value}
                    >
                    </InputMask>
                  )}
                ></Controller>
                {errors.phoneNumber?.type === "required" && (
                  <p className="text-danger" role="alert">
                    {errors.phoneNumber?.message}
                  </p>
                )}
              </div>

              <hr className="my-8 border-bd-primary"></hr>

              <p className="text-center">
                Al seleccionar{" "}
                <span className="text-font-light font-semibold">
                  Aceptar y continuar
                </span>
                , acepto los{" "}
                <a
                  href="/#/politicas"
                  target="_blank"
                  className="text-font-light link"
                >
                  Términos y Condiciones
                </a>
                , así <br />
                como{" "}
                <a
                  href="/#/politicas"
                  target="_blank"
                  className="text-font-light link"
                >
                  Política de privacidad
                </a>
                &nbsp; del Ministerio de Medio Ambiente y Recursos Naturales.
              </p>

              <button
                className="flex justify-center w-full uppercase rounded-[20rem] bg-primary text-xl rounded px-8 py-4 my-4 text-white"
                type="submit"
              >
                <span className="mr-4">Aceptar y continuar</span>{" "}
                {loadingSet.submitLoading && (
                  <div className="spinner-loading"></div>
                )}
              </button>
            </form>
          </div>

          <div className="flex flex-col justify-center mt-8 gap-y-4 text-lg">
            <div className="text-font-dark text-lg hr-divider">o</div>
            <div className="mx-auto">
              <GoogleSingIn
                theme="outline"
                type="standard"
                text={"Regístrate con Google"}
              ></GoogleSingIn>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
